<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.ant-table-row-selected{
  background-color: #171325ff;
}
</style>
<script>
// Enter full screen
window.requestFullscreen = function requestFullscreen() {
  if (document.documentElement.requestFullscreen) {
    document.getElementById("ant-layout-content").requestFullscreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
    document.getElementById("ant-layout-content").webkitRequestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) {
    document.getElementById("ant-layout-content").msRequestFullscreen();
  }
}

// Exit full screen
window.exitFullscreen =function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

// Listen for the F11 key press event
document.addEventListener('keydown', function(event) {
  if (event.keyCode === 122) { // F11 key code is 122
    window.requestFullscreen();
    event.preventDefault(); // Prevent the browser's default behavior
  }
});

// Listen for the ESC key press event
document.addEventListener('keydown', function(event) {
  if (event.keyCode === 27) { // ESC key code is 27
    window.exitFullscreen();
  }
});
</script>